import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function certificateReducer(
  state = initialState.certificateData,
  action
) {
  switch (action.type) {
    case types.CERTIFICATE_DATA:
      return action.certificateData || null;
    default:
      return state;
  }
}
